import React, { Component } from 'react'
import moment from 'moment'
import cx from 'classnames'
import { Popover, Pane, Body1, majorScale } from '@segment/react-ui-library'
import css from './Heatmap.module.css'

class Heatmap extends Component {
  constructor () {
    super()
    this.renderSquares = this.renderSquares.bind(this)
  }

  render () {
    const { skeleton } = this.props
    const rollingYear = getRollingYear()

    return (
      <div className={cx({
        [css.heatmap]: true,
        [css.skeleton]: skeleton
      })}>
        {this.renderYear(rollingYear)}
      </div>
    )
  }

  renderYear (rollingYear) {
    let totalCount = 0
    return rollingYear.map(({ month, year }) => {
      const { squares, count } = this.renderSquares(month, year, totalCount)
      totalCount = count

      return (
        <div key={month} className={css.month}>
          <div className={css.label}>{moment({ month: month }).format('MMM')}</div>
          <div className={css.column}>
            {squares}
          </div>
        </div>
      )
    })
  }

  /**
   * Render squares for the given `m` month.
   *
   * @param {Number} m
   * @param {Number} y
   */

  renderSquares (m, y, count) {
    const { values, levels } = this.props
    const month = moment({ month: m })
    const days = month.daysInMonth()
    const squares = []
    let totalCounter = count

    for (let i = 1; i <= days; i++) {
      let count = 0
      totalCounter++
      Object.keys(values).forEach(v => {
        const d = moment(v)
        if (d.month() === m && d.year() === y && d.date() === i) {
          count = values[v]
        }
      })

      let squareColor = null
      for (let i = 0; i < levels.length; i++) {
        const level = levels[i]
        const { max, min, color } = level
        if (count >= min && count <= max) {
          squareColor = color
          break
        }
      }

      const timestamp = moment().set('date', i).set('month', m).set('year', y).format('MMM Do YYYY')

      const animationDelay = `${totalCounter * 5}ms`

      squares.push(
        <Popover key={i} content={<PopoverContent timestamp={timestamp} count={count} />}>
          <div className={css.square} style={{ background: squareColor, animationDelay }} />
        </Popover>
      )
    }

    return { squares, count: totalCounter }
  }
}

const PopoverContent = ({ count, timestamp }) => (
  <Pane display='flex' alignItems='center' justifyContent='center' padding={majorScale(2)}>
    <Body1>{count} activities on {timestamp}</Body1>
  </Pane>
)

/**
 * Get the last 12 months.
 *
 * @return {Array}
 */

function getRollingYear () {
  const dateEnd = moment().endOf('month') // e.g. May 31, 2017
  const dateStart = moment().startOf('month').subtract('11', 'months') // e.g. June 1, 2016
  const timeValues = []

  while (dateEnd.isAfter(dateStart)) {
    timeValues.push({
      month: dateStart.get('month'),
      year: dateStart.get('year')
    })
    dateStart.add(1, 'month')
  }

  return timeValues
}

export default Heatmap



// WEBPACK FOOTER //
// ./components/Customers/presentational/Heatmap.js